export const camelCase = (text: string) => {
  if (text.length > 1)
    return text[0].toUpperCase() + text.slice(1).toLocaleLowerCase();
  return text;
};
